/**
 * @generated SignedSource<<2d1158e667456a5c8c74b9c86598cdba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedCreatorsResultContainer_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_viewer">;
  readonly " $fragmentType": "SbSharedCreatorsResultContainer_viewer";
};
export type SbSharedCreatorsResultContainer_viewer$key = {
  readonly " $data"?: SbSharedCreatorsResultContainer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedCreatorsResultContainer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedCreatorsResultContainer_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "7be0f88364222f97a85d9aa4cb064b49";

export default node;
